import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flyers-page" }
const _hoisted_2 = { class: "content-section" }
const _hoisted_3 = { class: "container" }
const _hoisted_4 = { class: "flyers-grid" }


export default /*@__PURE__*/_defineComponent({
  __name: 'FlyersView',
  setup(__props) {

// No special logic needed for this page

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("main", _hoisted_1, [
    _cache[5] || (_cache[5] = _createElementVNode("section", { class: "hero" }, [
      _createElementVNode("div", { class: "hero-content" }, [
        _createElementVNode("h1", null, "Flyers & Print Materials"),
        _createElementVNode("p", null, "Download and print materials to help spread the word about Space Coast STEM")
      ])
    ], -1)),
    _createElementVNode("section", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_router_link, {
            to: "/flyers/general",
            class: "flyer-card"
          }, {
            default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
              _createElementVNode("div", { class: "flyer-icon" }, "🎓", -1),
              _createElementVNode("h3", null, "General Information", -1),
              _createElementVNode("p", null, "For schools, guidance counselors, and social workers. Includes laptop request QR code and teacher signup info", -1),
              _createElementVNode("span", { class: "view-button" }, "View Flyer →", -1)
            ]))]),
            _: 1
          }),
          _createVNode(_component_router_link, {
            to: "/flyers/theplan",
            class: "flyer-card"
          }, {
            default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
              _createElementVNode("div", { class: "flyer-icon" }, "📋", -1),
              _createElementVNode("h3", null, "The Plan", -1),
              _createElementVNode("p", null, "Information about our bulk purchasing strategy and how we scale our impact", -1),
              _createElementVNode("span", { class: "view-button" }, "View Flyer →", -1)
            ]))]),
            _: 1
          }),
          _createVNode(_component_router_link, {
            to: "/flyers/it",
            class: "flyer-card"
          }, {
            default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
              _createElementVNode("div", { class: "flyer-icon" }, "💼", -1),
              _createElementVNode("h3", null, "IT Donation", -1),
              _createElementVNode("p", null, "Information for IT departments about donating equipment in bulk", -1),
              _createElementVNode("span", { class: "view-button" }, "View Flyer →", -1)
            ]))]),
            _: 1
          }),
          _createVNode(_component_router_link, {
            to: "/flyers/dropbox",
            class: "flyer-card"
          }, {
            default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
              _createElementVNode("div", { class: "flyer-icon" }, "📦", -1),
              _createElementVNode("h3", null, "Drop Box Location", -1),
              _createElementVNode("p", null, "Signage for laptop drop-off locations with QR code and contact info", -1),
              _createElementVNode("span", { class: "view-button" }, "View Flyer →", -1)
            ]))]),
            _: 1
          })
        ]),
        _cache[4] || (_cache[4] = _createElementVNode("div", { class: "print-info" }, [
          _createElementVNode("h2", null, "Printing Tips"),
          _createElementVNode("ul", null, [
            _createElementVNode("li", null, "All flyers are designed for standard 8.5\" x 11\" letter-size paper"),
            _createElementVNode("li", null, "Use your browser's print function (Ctrl+P or Cmd+P) to print"),
            _createElementVNode("li", null, "Select \"Print backgrounds\" or \"Background graphics\" for best results"),
            _createElementVNode("li", null, "For professional results, consider printing on cardstock or laminating")
          ])
        ], -1))
      ])
    ])
  ]))
}
}

})